
<template>
  <!-- 附件表格展示 -->
  <el-table
    v-if="attachs.length !== 0"
    class="felilist"
    :data="attachs"
    :show-header="false"
    :row-class-name="tableRowClassName"
    :header-cell-style="headClass"
  >
    <el-table-column type="index" label="序号" width="50" />
    <el-table-column label="文件名称" show-overflow-tooltip>
      <template slot-scope="scope">
        <el-row :gutter="20">
          <el-col :span="12" style="overflow: hidden">
            <div style="margin-top: 10px">{{ scope.row.fileName }}</div>
          </el-col>
          <el-col :span="9">
            <div>
              <el-button type="text" @click.native="showfile(scope.row)"
                >预览</el-button
              >
              <el-button type="text" @click="downfile(scope.row)"
                >下载</el-button
              >
              <el-button
                v-if="type === 'SP'"
                type="text"
                style="color: #f56c6c"
                @click="attachsdelect(scope.$index, scope.row)"
                >删除</el-button
              >
            </div>
          </el-col>
        </el-row>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'BoxFileList',
  props: {
    attachs: Array,
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fileItem: {}
    }
  },
  created () { },

  methods: {
    attachsdelect (index) {
      for (var i = 0; i < this.attachs.length; i++) {
        if (Number(index) === i) {
          this.attachs.splice(index, 1)
        }
      }
    },
    showfile (item) {
      // 文件预览
      var arr = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']
      var arr1 = ['jpg', 'jpeg', 'bmp', 'gif', 'png', 'pdf', 'txt']
      if (arr.indexOf(item.fileType) > -1) {
        window.open(
          '/api/storageFile/preview/getPreviewPath?filePath=' + item.filePath,
          '_blank'
        )
      } else if (arr1.indexOf(item.fileType) > -1) {
        window.open(
          '/api/storageFile/fdfs/showFile?filePath=' + item.filePath,
          '_blank'
        )
      } else {
        this.$message.info('该文件不支持预览')
      }
    },
    downfile (item) {
      // 文件下载
      window.open(
        '/api/storageFile/fdfs/downloadFile?filePath=' +
        item.filePath +
        '&fileName=' +
        encodeURIComponent(item.fileName),
        '_self'
      )
    },
    showfile (item) {
      // 文件预览
      var arr = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']
      var arr1 = ['jpg', 'jpeg', 'bmp', 'gif', 'png', 'pdf', 'txt']
      if (arr.indexOf(item.fileType) > -1) {
        window.open(
          '/api/storageFile/preview/getPreviewPath?filePath=' + item.filePath,
          '_blank'
        )
      } else if (arr1.indexOf(item.fileType) > -1) {
        window.open(
          '/api/storageFile/fdfs/showFile?filePath=' + item.filePath,
          '_blank'
        )
      } else {
        this.$message.info('该文件不支持预览')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.felilist {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
